import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import { Refresh, WifiOff } from "@mui/icons-material";

/**
 * Blocking alert shown on the tagging screens while the realtime link is down.
 * There is no dismiss action on purpose — the video timestamp cannot be trusted
 * until the connection is back, so tagging must stay blocked.
 */
const AblyOfflineAlert = ({ open, retrying, onRetry }) => (
  <Dialog
    open={!!open}
    disableEscapeKeyDown
    PaperProps={{
      sx: {
        borderRadius: "12px",
        minWidth: 360,
        maxWidth: "92vw",
        border: "1px solid var(--border-1)",
      },
    }}
  >
    <DialogTitle
      sx={{
        backgroundColor: "rgba(185, 28, 28, 0.08)",
        borderBottom: "2px solid rgba(185, 28, 28, 1)",
        py: 1.5,
      }}
    >
      <Stack direction="row" alignItems="center" gap={1}>
        <WifiOff sx={{ fontSize: 18, color: "rgba(185, 28, 28, 1)" }} />
        <Typography
          sx={{ fontSize: "15px", fontWeight: 700, color: "rgba(185, 28, 28, 1)" }}
        >
          Connection lost
        </Typography>
      </Stack>
    </DialogTitle>
    <DialogContent sx={{ py: 2 }}>
      <Typography sx={{ fontSize: "13px", color: "var(--text-2)", mt: 1 }}>
        Tagging is blocked because the video timestamp is no longer in sync.
        {retrying
          ? " Reconnecting…"
          : " Tagging resumes automatically once the connection returns."}
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 2, pb: 2 }}>
      <Button
        variant="contained"
        size="small"
        disabled={!!retrying}
        onClick={onRetry}
        startIcon={<Refresh sx={{ fontSize: "16px !important" }} />}
        sx={{
          textTransform: "none",
          borderRadius: "8px",
          fontSize: "12px",
          fontWeight: 700,
          backgroundColor: "rgba(185, 28, 28, 1)",
          "&:hover": { backgroundColor: "rgba(153, 23, 23, 1)" },
        }}
      >
        {retrying ? "Retrying…" : "Retry"}
      </Button>
    </DialogActions>
  </Dialog>
);

export default AblyOfflineAlert;
